import React from 'react'
import { cn } from '../../lib/utils'
import type { IconSize, BaseComponentProps } from '../../types'

export interface IconProps extends Omit<BaseComponentProps, 'children'> {
  name: string
  size?: IconSize
  color?: string
  spin?: boolean
}

const sizeClasses: Record<IconSize, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
}

/**
 * Icon component wrapping Font Awesome icons
 * Requires Font Awesome to be loaded in index.html
 */
export const Icon: React.FC<IconProps> = ({
  name,
  size = 'md',
  color,
  spin = false,
  className,
  style,
  ...props
}) => {
  return (
    <i
      className={cn(
        'fa',
        `fa-${name}`,
        sizeClasses[size],
        spin && 'fa-spin',
        className
      )}
      style={{ color, ...style }}
      aria-hidden="true"
      {...props}
    />
  )
}

/**
 * Solid icon variant
 */
export const IconSolid: React.FC<IconProps> = (props) => (
  <Icon {...props} className={cn('fas', props.className)} />
)

/**
 * Regular icon variant
 */
export const IconRegular: React.FC<IconProps> = (props) => (
  <Icon {...props} className={cn('far', props.className)} />
)

/**
 * Brand icon variant
 */
export const IconBrand: React.FC<IconProps> = (props) => (
  <Icon {...props} className={cn('fab', props.className)} />
)
